module.exports = __webpack_public_path__ + "img/img-e052d4.png";